// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__30H63","shimmer":"styles_shimmer__2_1JZ","icon":"styles_icon__8li87"};